import { apiClient } from './client';
import type {
  ChangePasswordPayload,
  IndividualProfile,
  UpdateIndividualProfilePayload,
} from '@/lib/types/profile.types';

/**
 * The current individual person's account (FR-09) from `GET /v1/me`. The
 * backend response shape matches `IndividualProfile` one-to-one (see the
 * backend `IndividualAccountDto`).
 */
export async function getMyProfile(): Promise<IndividualProfile> {
  const { data } = await apiClient.get<IndividualProfile>('/me');
  return data;
}

/**
 * Updates the current individual person's editable account fields (FR-09)
 * via `PATCH /v1/me`. Email is excluded - it goes through a separate IdP
 * verification flow, not this endpoint.
 */
export async function updateMyProfile(
  payload: UpdateIndividualProfilePayload,
): Promise<IndividualProfile> {
  const { data } = await apiClient.patch<IndividualProfile>('/me', payload);
  return data;
}

/** Changes the current user's password via `PATCH /v1/me/password`. */
export async function changeMyPassword(payload: ChangePasswordPayload): Promise<void> {
  await apiClient.patch('/me/password', payload);
}

/** Soft-deletes the current user's account via `DELETE /v1/me`. */
export async function deleteMyAccount(): Promise<void> {
  await apiClient.delete('/me');
}
